export default "__VITE_ASSET__1a8cc519__"